import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { TypeDocumentGarantie } from "src/app/parametrage/core/model/garanties/type-document-garantie";
import { TypeDocumentChampGarantieService } from "src/app/parametrage/core/service/type-document-champ-garantie.service";

@Component({
  selector: "app-add-type-document-garantie",
  templateUrl: "./add-type-document-garantie.component.html",
  styleUrls: ["./add-type-document-garantie.component.scss"],
})
export class AddTypeDocumentGarantieComponent implements OnInit {
  typeDocumentGarantie: TypeDocumentGarantie;
  form: FormGroup;
  pressButton: Boolean = false;
  submitted = false;
  errorMessage: string;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _typeDocumentGarantieService: TypeDocumentChampGarantieService) {}

  ngOnInit() {
    this.form = this.createForm(this.typeDocumentGarantie);
  }

  createForm(data: TypeDocumentGarantie) {
    if (data) {
      return this.fb.group({
        id: [data ? data.id : ""],
        code: [
          data ? data.code : "",
          Validators.compose([Validators.required]),
        ],
        libelle: [data ? data.libelle : ""],
      });
    } else {
      return this.fb.group({
        id: [data ? data.id : ""],
        code: ["", Validators.compose([Validators.required])],
        libelle: ["", Validators.compose([Validators.required])],
      });
    }
  }

  onSubmit() {
    this.submitted = true;
    this.findInvalidControls();
    if (this.form.invalid) {
      return;
    }
    if (!this.typeDocumentGarantie) {
      this.createData();
    } else {
      this.updateData();
    }
  }

  createData() {
    this._typeDocumentGarantieService
      .addTypeDocumentGarantie(this.form.value)
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          if (error && error.error && error.status == 409) {
            this.errorMessage = error.error.message;
          }
          this.pressButton = false;
        }
      );
  }

  updateData() {
    this._typeDocumentGarantieService
      .updateTypeDocumentGarantie(this.typeDocumentGarantie.id, this.form.value)
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          if (error && error.error && error.status == 409) {
            this.errorMessage = error.error.message;
          }
          this.pressButton = false;
        }
      );
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log(invalid);
  }
}
